import Main from "./component.main";
import store from "./script.store";
const Connexion = { Main, store };
export default Connexion;
